<main class="modal modal--{{ isOpen() ? 'open' : 'close' }}">
  <header class="top-bar">
    <button (click)="close()" class="h-6">
      <mat-icon class="material-symbols-rounded scale-100">close</mat-icon>
      <span class="sr-only">schließen</span>
    </button>
  </header>
  @if (data) {
    <div class="modal-inner">
      <ng-container *ngTemplateOutlet="data"></ng-container>
    </div>
  }
</main>
